// src/app/modules/Visitors/pages/visitors-table/VisitorsTable.jsx
import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { ChevronLeft, ChevronRight } from 'lucide-react';
import * as columnFormatters from "./column-formatters";

export function VisitorsTable({
  onViewDetails,
  onFlag,
  onAddThreat,
  onBlacklist,
  onPageChange,
  currentPage,
  perPage
}) {
  const { visitors, visitors_meta, loading } = useSelector(
    (state) => ({
      visitors: state.dashboard.visitors || [],
      visitors_meta: state.dashboard.visitorsMeta,
      loading: state.dashboard.actionsLoading,
    }),
    shallowEqual
  );

  const totalResults = visitors_meta?.totalResults || 0;
  const totalPages = Math.max(1, Math.ceil(totalResults / (perPage || 10)));
  const extra = { onViewDetails, onFlag, onAddThreat, onBlacklist };

  if (loading && !visitors.length) {
    return <div className="sety-tbl-sub" style={{ padding: 22 }}>Loading…</div>;
  }

  if (!visitors.length) {
    return <div className="sety-tbl-sub" style={{ padding: 22 }}>No visitor profiles found.</div>;
  }

  return (
    <div>
      <div className="sety-tbl-wrap">
        <table className="sety-tbl">
          <thead>
            <tr>
              <th>Visitor</th>
              <th>Risk Level</th>
              <th>Visit Stats</th>
              <th>Last Visit</th>
              <th style={{ textAlign: 'right' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {visitors.map((row) => (
              <tr key={row.profile_id}>
                <td>{columnFormatters.VisitorColumnFormatter(row.visitor_name, row)}</td>
                <td>{columnFormatters.RiskScoreFormatter(row.risk_score, row)}</td>
                <td>{columnFormatters.VisitStatsFormatter(row['visit_statistics.total_visits'], row)}</td>
                <td>{columnFormatters.LastVisitFormatter(row['visit_statistics.last_visit'], row)}</td>
                <td style={{ textAlign: 'right' }}>
                  {columnFormatters.ActionsColumnFormatter(null, row, 0, extra)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '14px 22px', borderTop: '1px solid var(--ink-100)',
        }}>
          <span className="sety-tbl-sub">Page {currentPage} of {totalPages}</span>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="sety-btn sety-btn-ghost" disabled={currentPage <= 1} onClick={() => onPageChange(currentPage - 1)}>
              <ChevronLeft size={14} />Prev
            </button>
            <button className="sety-btn sety-btn-ghost" disabled={currentPage >= totalPages} onClick={() => onPageChange(currentPage + 1)}>
              Next<ChevronRight size={14} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
